import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { StoredReportSchema, PaginationQuerySchema, PaginationMetaSchema, DateRangeQuerySchema, DatePathParamSchema, ErrorResponseSchema, } from './schemas';
const c = initContract();
export const reportsContract = c.router({
    list: {
        method: 'GET',
        path: '/reports',
        query: PaginationQuerySchema.merge(DateRangeQuerySchema).extend({
            employeeId: z.string().optional(),
        }),
        responses: {
            200: z.object({
                success: z.literal(true),
                data: z.array(StoredReportSchema),
                meta: PaginationMetaSchema.optional(),
            }),
            400: ErrorResponseSchema,
            401: ErrorResponseSchema,
        },
        summary: 'List reports with optional filters',
    },
    daily: {
        method: 'GET',
        path: '/reports/daily/:date',
        pathParams: DatePathParamSchema,
        responses: {
            200: z.object({
                success: z.literal(true),
                data: z.array(StoredReportSchema),
            }),
            400: ErrorResponseSchema,
            401: ErrorResponseSchema,
        },
        summary: 'Get all reports for a specific date',
    },
    export: {
        method: 'GET',
        path: '/reports/export',
        query: DateRangeQuerySchema.extend({
            employeeId: z.string().optional(),
        }),
        responses: {
            200: z.string(),
            400: ErrorResponseSchema,
            401: ErrorResponseSchema,
        },
        summary: 'Export reports as CSV',
    },
});
//# sourceMappingURL=reports.js.map